import { cn } from "@/lib/utils";
import type { HttpMethod as HttpMethodType } from "@/types";

interface HttpMethodProps {
  method: HttpMethodType | string;
  className?: string;
}

export function HttpMethod({ method, className }: HttpMethodProps) {
  const getMethodColor = (method: string): string => {
    switch (method.toUpperCase()) {
      case "GET":
        return "text-[#3B9EFF]";
      case "POST":
        return "text-[#F59E0B]";
      case "PUT":
      case "PATCH":
        return "text-[#F97316]";
      case "DELETE":
        return "text-[#EF4444]";
      case "OPTIONS":
        return "text-[#A855F7]";
      case "HEAD":
        return "text-[#6B7280]";
      default:
        return "text-foreground";
    }
  };

  return (
    <span className={cn(getMethodColor(method), className)}>{method}</span>
  );
}
